module.exports = __webpack_public_path__ + "img/5.6b5555cf.jpg";